export const mutationNames = {
  SET_LOADER: 'SET_LOADER',
  SET_DEVICE: 'SET_DEVICE',
  SET_RESOURCE: 'SET_RESOURCE',
  SET_LANGUAGE: 'SET_LANGUAGE',
  SET_USER: 'SET_USER',
  SET_SUBSCRIPTIONS: 'SET_SUBSCRIPTIONS',
  SET_ACTIVE_SUBSCRIPTION_ID: 'SET_ACTIVE_SUBSCRIPTION_ID',
  SET_THEMES_BACKGROUND_COLORS: 'SET_THEMES_BACKGROUND_COLORS',
  SET_APP_THEMES: 'SET_APP_THEMES',
  SET_FONTS: 'SET_FONTS',
  SET_FONTSFAMILIES: 'SET_FONTSFAMILIES',
  SET_DESIGN_SETTINGS: 'SET_DESIGN_SETTINGS',
  SET_START_PAGE: 'SET_START_PAGE',
  SET_SUBSCRIPTIONS_MODULES: 'SET_SUBSCRIPTIONS_MODULES',
  UPDATE_SUBSCRIPTIONS_MODULE: 'UPDATE_SUBSCRIPTIONS_MODULE',
  SET_TEXTURE_IMAGES: 'SET_TEXTURE_IMAGES',
  UPDATE_DESIGNSETTINGS: 'UPDATE_DESIGNSETTINGS',
  SET_IMAGEDIALOUGEDISPLAY: 'SET_IMAGEDIALOUGEDISPLAY',
  SET_ICONDIALOUGEDISPLAY: 'SET_ICONDIALOUGEDISPLAY',
  SET_ICONS: 'SET_ICONS',
  SET_CATEGORY_FILLED_ICONS: 'SET_CATEGORY_FILLED_ICONS',
  SET_CATEGORY_OUTLINED_ICONS: 'SET_CATEGORY_OUTLINED_ICONS',
  SET_ICONCATEGORY: 'SET_ICONCATEGORY',
  SET_DOMAIN_SETTINGS: 'SET_DOMAIN_SETTINGS',
  SET_SYSTEMSTORE: 'SET_SYSTEMSTORE',
  SET_SYSTEM_APP_TEMPALTE_CATEGORY: 'SET_SYSTEM_APP_TEMPALTE_CATEGORY',
  SET_SYSTEM_APP_TEMPALTE: 'SET_SYSTEM_APP_TEMPALTE',
  UPDATE_START_PAGE_SETTINGS: 'UPDATE_START_PAGE_SETTINGS',
  UPDATE_DESIGN_SETTINGS: 'UPDATE_DESIGN_SETTINGS',
  UPDATE_BACKGROUND_DESIGN_SETTINGS: 'UPDATE_BACKGROUND_DESIGN_SETTINGS',
  UPDATE_APPTHEME_DESIGN_SETTINGS: 'UPDATE_APPTHEME_DESIGN_SETTINGS',
  UPDATE_BACKGROUND_IMAGE_DESIGN_SETTINGS: 'UPDATE_BACKGROUND_IMAGE_DESIGN_SETTINGS',
  UPDATE_IMAGE_START_PAGE_SETTINGS: 'UPDATE_IMAGE_START_PAGE_SETTINGS',

  SET_ACTIVE_MODULE: 'SET_ACTIVE_MODULE',
  SET_STREAM: 'SET_STREAM',
  UPDATE_STREAM: 'UPDATE_STREAM',
  UPDATE_STREAM_COVER_IMAGE: 'UPDATE_STREAM_COVER_IMAGE',

  SET_RSSFEEDDATA: 'SET_RSSFEEDDATA',
  UPDATE_RSSFEEDDATA: 'UPDATE_RSSFEEDDATA',

  ROUTE_CHANGED: 'route/ROUTE_CHANGED',
  SHOW_APPPREVIEWER_LINK: 'SHOW_APPPREVIEWER_LINK',

  SET_TEAM_PARENT: 'SET_TEAM_PARENT',
  SET_TEAM_MEMBER: 'SET_TEAM_MEMBER',
  ADD_TEAMPRESON: 'ADD_TEAMPRESON',
  UPDATE_TEAMPARENT: 'UPDATE_TEAMPARENT',
  UPDATE_TEAMPRESON: 'UPDATE_TEAMPRESON',
  UPDATE_TEAM_PERSON_IMAGE: 'UPDATE_TEAM_PERSON_IMAGE',

  SET_FACEBOOK_PARENT: 'SET_FACEBOOK_PARENT',
  UPDATE_CONTENT_PARENT: 'UPDATE_CONTENT_PARENT',
  UPDATE_CONTENT_PAGE: 'UPDATE_CONTENT_PAGE',
  SET_CONTENT_PAGES: 'SET_CONTENT_PAGES',
  SET_CONTENT_PAGE_PARENT: 'SET_CONTENT_PAGE_PARENT',
  UPDATE_CONTENT_PAGE_IMAGE: 'UPDATE_CONTENT_PAGE_IMAGE',
  CREATE_NEW_CONTENT_PAGE: 'CREATE_NEW_CONTENT_PAGE',
  UPDATE_NEW_CONTENT_PAGE: 'UPDATE_NEW_CONTENT_PAGE',
  SET_CONTENT_EDITING_PAGE: 'SET_CONTENT_EDITING_PAGE',
  CLEAR_CONTENT_EDITING_DATA: 'CLEAR_CONTENT_EDITING_DATA',
  CANCEL_CONTENT_PAGE_EDITING: 'CANCEL_CONTENT_PAGE_EDITING',
  SET_SYSTEM_SUBSCRIPTION_MODULES: 'SET_SYSTEM_SUBSCRIPTION_MODULES',
  SET_SUBSCRIPTION_LEVEL_ID: 'SET_SUBSCRIPTION_LEVEL_ID',
  SET_PURCHASED_SUBSCRIPTION_LEVEL_ID: 'SET_PURCHASED_SUBSCRIPTION_LEVEL_ID',
  CURRENT_ACTIVE_EVENT_TAB: 'CURRENT_ACTIVE_EVENT_TAB',

  SET_IMAGE_GALLERIE_ALBUMS: 'SET_IMAGE_GALLERIE_ALBUMS',
  SET_IMAGE_GALLERIE_PARENT: 'SET_IMAGE_GALLERIE_PARENT',
  UPDATE_IMAGE_GALLERIE_PARENT: 'UPDATE_IMAGE_GALLERIE_PARENT',
  UPDATE_IMAGE_GALLERIE_ALBUM: 'UPDATE_IMAGE_GALLERIE_ALBUM',
  CREATE_NEW_IMAGE_GALLERIE_ALBUM: 'CREATE_NEW_IMAGE_GALLERIE_ALBUM',
  UPDATE_NEW_IMAGE_GALLERIE_ALBUM: 'UPDATE_NEW_IMAGE_GALLERIE_ALBUM',
  SET_IMAGE_GALLERIE_EDITING_ALBUM: 'SET_IMAGE_GALLERIE_EDITING_ALBUM',
  CLEAR_IMAGE_GALLERIE_ALBUM_EDITING_DATA: 'CLEAR_IMAGE_GALLERIE_ALBUM_EDITING_DATA',
  CANCEL_IMAGE_GALLERIE_ALBUM_EDITING: 'CANCEL_IMAGE_GALLERIE_ALBUM_EDITING',

  SET_YOUTUBE: 'SET_YOUTUBE',
  UPDATE_YOUTUBE: 'UPDATE_YOUTUBE',

  SET_WEBSITE: 'SET_WEBSITE',
  UPDATE_WEBSITE: 'UPDATE_WEBSITE',

  SET_INSTAGRAM: 'SET_INSTAGRAM',
  UPDATE_INSTAGRAM: 'UPDATE_INSTAGRAM',

  SET_FACEBOOK: 'SET_FACEBOOK',
  UPDATE_FACEBOOK: 'UPDATE_FACEBOOK',
  SET_MODULE_DATA: 'SET_MODULE_DATA',
  UPDATE_MODULE_DATA: 'UPDATE_MODULE_DATA',
  RESET_MODULE_DATA: 'RESET_MODULE_DATA',

  SET_CHAT_MODULE_INFO: 'SET_CHAT_MODULE_INFO',
  UPDATE_CHAT_MODULE_INFO: 'UPDATE_CHAT_MODULE_INFO',
  ADD_CHATCHANNEL: 'ADD_CHATCHANNEL',
  UPDATE_CHAT_CHANNEL: 'UPDATE_CHAT_CHANNEL',
  SET_CHAT_CHANNEL: 'SET_CHAT_CHANNEL',
  SET_CHAT_MESSAGES: 'SET_CHAT_MESSAGES',
  UPDATE_CHAT_CHANNEL_IMAGE: 'UPDATE_CHAT_CHANNEL_IMAGE',
  CREATE_NEW_CHAT_CHANNEL: 'CREATE_NEW_CHAT_CHANNEL',
  SET_CHAT_CHANNEL_EDITING: 'SET_CHAT_CHANNEL_EDITING',
  UPDATE_NEW_CHAT_CHANNEL: 'UPDATE_NEW_CHAT_CHANNEL',
  CLEAR_CHAT_CHANNEL_EDITING_DATA: 'CLEAR_CHAT_CHANNEL_EDITING_DATA',
  CANCEL_CHAT_CHANNEL_EDITING: 'CANCEL_CHAT_CHANNEL_EDITING',
  UPDATE_OPEN_CHAT: 'UPDATE_OPEN_CHAT',
  SET_OPEN_CHAT_Id: 'SET_OPEN_CHAT_Id',

  SET_TWITTER_PARENT: 'SET_TWITTER_PARENT',
  UPDATE_TWITTERDATA: 'UPDATE_TWITTERDATA',
  SET_TWITTER_ERRORFOUND: 'SET_TWITTER_ERRORFOUND',
  SET_ACTIVEDEVICE: 'SET_ACTIVEDEVICE',
  SET_DEVSIM_LOADED: 'SET_DEVSIM_LOADED',
  SET_ACTIVEPIN: 'SET_ACTIVEPIN',
  SET_VERIFICATIONPIN: 'SET_VERIFICATIONPIN',
  SET_USERREGISTRATION: 'SET_USERREGISTRATION',

  SET_CUSTOMCODE: 'SET_CUSTOMCODE',
  UPDATE_CUSTOMCODE: 'UPDATE_CUSTOMCODE',

  SET_PDFMODULEINFO: 'SET_PDFMODULEINFO',
  UPDATE_PDFMODULEINFO: 'UPDATE_PDFMODULEINFO',
  UPDATE_PDFDOCLIST: 'UPDATE_PDFDOCLIST',

  NAMESPACES: {
    'UPDATE_STREAM': 'radioStream/UPDATE_STREAM',
    'UPDATE_STREAM_COVER_IMAGE': 'radioStream/UPDATE_STREAM_COVER_IMAGE',

    'SET_CONTENT_PAGE_PARENT': 'textContent/SET_CONTENT_PAGE_PARENT',
    'SET_CONTENT_PAGES': 'textContent/SET_CONTENT_PAGES',
    'UPDATE_CONTENT_PARENT': 'textContent/UPDATE_CONTENT_PARENT',
    'UPDATE_CONTENT_PAGE': 'textContent/UPDATE_CONTENT_PAGE',
    'UPDATE_CONTENT_PAGE_IMAGE': 'textContent/UPDATE_CONTENT_PAGE_IMAGE',
    'CREATE_NEW_CONTENT_PAGE': 'textContent/CREATE_NEW_CONTENT_PAGE',
    'UPDATE_NEW_CONTENT_PAGE': 'textContent/UPDATE_NEW_CONTENT_PAGE',
    'SET_CONTENT_EDITING_PAGE': 'textContent/SET_CONTENT_EDITING_PAGE',
    'CLEAR_CONTENT_EDITING_DATA': 'textContent/CLEAR_CONTENT_EDITING_DATA',
    'CANCEL_CONTENT_PAGE_EDITING': 'textContent/CANCEL_CONTENT_PAGE_EDITING',
    'CURRENT_ACTIVE_EVENT_TAB': 'textContent/CURRENT_ACTIVE_EVENT_TAB',

    'SET_IMAGE_GALLERIE_PARENT': 'imageGalleryModule/SET_IMAGE_GALLERIE_PARENT',
    'SET_IMAGE_GALLERIE_ALBUMS': 'imageGalleryModule/SET_IMAGE_GALLERIE_ALBUMS',
    'UPDATE_IMAGE_GALLERIE_PARENT': 'imageGalleryModule/UPDATE_IMAGE_GALLERIE_PARENT',
    'UPDATE_IMAGE_GALLERIE_ALBUM': 'imageGalleryModule/UPDATE_IMAGE_GALLERIE_ALBUM',
    'CREATE_NEW_IMAGE_GALLERIE_ALBUM': 'imageGalleryModule/CREATE_NEW_IMAGE_GALLERIE_ALBUM',
    'UPDATE_NEW_IMAGE_GALLERIE_ALBUM': 'imageGalleryModule/UPDATE_NEW_IMAGE_GALLERIE_ALBUM',
    'SET_IMAGE_GALLERIE_EDITING_ALBUM': 'imageGalleryModule/SET_IMAGE_GALLERIE_EDITING_ALBUM',
    'CLEAR_IMAGE_GALLERIE_ALBUM_EDITING_DATA': 'imageGalleryModule/CLEAR_IMAGE_GALLERIE_ALBUM_EDITING_DATA',
    'CANCEL_IMAGE_GALLERIE_ALBUM_EDITING': 'imageGalleryModule/CANCEL_IMAGE_GALLERIE_ALBUM_EDITING',
    'UPDATE_YOUTUBE': 'youtube/UPDATE_YOUTUBE',
    'UPDATE_RSSFEEDDATA': 'rssfeed/UPDATE_RSSFEEDDATA',
    'SET_MODULE_DATA': 'formModule/SET_MODULE_DATA',
    'UPDATE_MODULE_DATA': 'formModule/UPDATE_MODULE_DATA',
    'RESET_MODULE_DATA': 'formModule/RESET_MODULE_DATA',
    'SET_WEBSITE': 'website/SET_WEBSITE',
    'UPDATE_WEBSITE': 'website/UPDATE_WEBSITE',
    'SET_CHAT_MODULE_INFO': 'chat/SET_CHAT_MODULE_INFO',
    'UPDATE_CHAT_MODULE_INFO': 'chat/UPDATE_CHAT_MODULE_INFO',
    'ADD_CHATCHANNEL': 'chat/ADD_CHATCHANNEL',
    'UPDATE_CHAT_CHANNEL': 'chat/UPDATE_CHAT_CHANNEL',
    'SET_CHAT_CHANNEL': 'chat/SET_CHAT_CHANNEL',
    'SET_CHAT_MESSAGES': 'chat/SET_CHAT_MESSAGES',
    'UPDATE_CHAT_CHANNEL_IMAGE': 'chat/UPDATE_CHAT_CHANNEL_IMAGE',
    'CREATE_NEW_CHAT_CHANNEL': 'chat/CREATE_NEW_CHAT_CHANNEL',
    'SET_CHAT_CHANNEL_EDITING': 'chat/SET_CHAT_CHANNEL_EDITING',
    'UPDATE_NEW_CHAT_CHANNEL': 'chat/UPDATE_NEW_CHAT_CHANNEL',
    'CLEAR_CHAT_CHANNEL_EDITING_DATA': 'chat/CLEAR_CHAT_CHANNEL_EDITING_DATA',
    'CANCEL_CHAT_CHANNEL_EDITING': 'chat/CANCEL_CHAT_CHANNEL_EDITING',
    'UPDATE_OPEN_CHAT': 'chat/UPDATE_OPEN_CHAT',
    'SET_OPEN_CHAT_Id': 'chat/SET_OPEN_CHAT_Id',
    'SET_INSTAGRAM': 'instagram/SET_INSTAGRAM',
    'SET_TWITTER_PARENT': 'SET_TWITTER_PARENT',
    'SET_TWITTER_ERRORFOUND': 'SET_TWITTER_ERRORFOUND',
    'UPDATE_TWITTERDATA': 'twitter/UPDATE_TWITTERDATA',
    'SET_FACEBOOK': 'facebook/SET_FACEBOOK',
    'UPDATE_FACEBOOK': 'facebook/UPDATE_FACEBOOK',
    'UPDATE_INSTAGRAM': 'instagram/UPDATE_INSTAGRAM',
    'SET_ACTIVEDEVICE': 'SET_ACTIVEDEVICE',
    'SET_DEVSIM_LOADED': 'SET_DEVSIM_LOADED',
    'SET_ACTIVEPIN': 'SET_ACTIVEPIN',
    'SET_VERIFICATIONPIN': 'SET_VERIFICATIONPIN',
    'SET_USERREGISTRATION': 'SET_USERREGISTRATION',
    'SET_CUSTOMCODE': 'customCode/SET_CUSTOMCODE',
    'UPDATE_CUSTOMCODE': 'customCode/UPDATE_CUSTOMCODE',
    'SET_PDFMODULEINFO': 'pdfModule/SET_PDFMODULEINFO',
    'UPDATE_PDFMODULEINFO': 'pdfModule/UPDATE_PDFMODULEINFO',
    'UPDATE_PDFDOCLIST': 'UPDATE_PDFDOCLIST'
  }
}



// WEBPACK FOOTER //
// ./src/store/storeKey.js